/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

/* plain JS slideToggle https://github.com/ericbutler555/plain-js-slidetoggle */
HTMLElement.prototype.slideToggle = function (duration, callback) {
  if (this.clientHeight === 0) {
    _s(this, duration, callback, true);
  } else {
    _s(this, duration, callback);
  }
};

HTMLElement.prototype.slideUp = function (duration, callback) {
  _s(this, duration, callback);
};

HTMLElement.prototype.slideDown = function (duration, callback) {
  _s(this, duration, callback, true);
};

function _s(el, duration, callback, isDown) {
  if (typeof duration === "undefined") duration = 400;
  if (typeof isDown === "undefined") isDown = false;

  el.style.overflow = "hidden";
  if (isDown) el.style.display = "block";

  var elStyles = window.getComputedStyle(el);

  var elHeight = parseFloat(elStyles.getPropertyValue("height"));
  var elPaddingTop = parseFloat(elStyles.getPropertyValue("padding-top"));
  var elPaddingBottom = parseFloat(elStyles.getPropertyValue("padding-bottom"));
  var elMarginTop = parseFloat(elStyles.getPropertyValue("margin-top"));
  var elMarginBottom = parseFloat(elStyles.getPropertyValue("margin-bottom"));

  var stepHeight = elHeight / duration;
  var stepPaddingTop = elPaddingTop / duration;
  var stepPaddingBottom = elPaddingBottom / duration;
  var stepMarginTop = elMarginTop / duration;
  var stepMarginBottom = elMarginBottom / duration;

  var start;

  function step(timestamp) {
    if (start === undefined) start = timestamp;

    var elapsed = timestamp - start;

    if (isDown) {
      el.style.height = stepHeight * elapsed + "px";
      el.style.paddingTop = stepPaddingTop * elapsed + "px";
      el.style.paddingBottom = stepPaddingBottom * elapsed + "px";
      el.style.marginTop = stepMarginTop * elapsed + "px";
      el.style.marginBottom = stepMarginBottom * elapsed + "px";
    } else {
      el.style.height = elHeight - stepHeight * elapsed + "px";
      el.style.paddingTop = elPaddingTop - stepPaddingTop * elapsed + "px";
      el.style.paddingBottom =
        elPaddingBottom - stepPaddingBottom * elapsed + "px";
      el.style.marginTop = elMarginTop - stepMarginTop * elapsed + "px";
      el.style.marginBottom =
        elMarginBottom - stepMarginBottom * elapsed + "px";
    }

    if (elapsed >= duration) {
      el.style.height = "";
      el.style.paddingTop = "";
      el.style.paddingBottom = "";
      el.style.marginTop = "";
      el.style.marginBottom = "";
      el.style.overflow = "";
      if (!isDown) el.style.display = "none";
      if (typeof callback === "function") callback();
    } else {
      window.requestAnimationFrame(step);
    }
  }

  window.requestAnimationFrame(step);
}

// Envision - read-more component events
(function () {
  let readMoreToggleEvent = (e) => {
    e.stopImmediatePropagation();
    e.stopPropagation();

    try {
      let readMoreComponent = e.target.closest(".read-more--component");
      let contentContainer =
        readMoreComponent.querySelector(".content-container");
      if (readMoreComponent.classList.contains("active")) {
        readMoreComponent.classList.remove("active");
        contentContainer.slideUp(200);
      } else {
        readMoreComponent.classList.add("active");
        contentContainer.slideDown(200);
      }
      return false;
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  let readMoreButtons = document.querySelectorAll(
    ".read-more--component a.read-more--button"
  );
  if (readMoreButtons.length) {
    readMoreButtons.forEach((element) =>
      element.addEventListener("click", readMoreToggleEvent)
    );
  }
})();

// Envision - initialize custom product page wishlist button
(function () {
  function swymCallbackFn(swat) {
    // your API calls go here
    document.addEventListener("swym:experience-product-loaded", function () {
      swat.initializeActionButtons(".product-top-buttons-social-wrapper");
    });
  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);

  document.dispatchEvent(new CustomEvent("swym:experience-product-loaded"));
})();

// Envision - custom collection filter component scripts
(function () {
  class CustomCollectionFilterComponent {
    constructor() {
      this.component = document.querySelector(".collection-filter--component");
      this.sidebar = document.querySelector("[data-collection-sidebar]");

      if (this.component && this.sidebar) {
        this.locationFilterGroup = this.component.querySelector(".collection-filter-component--location [data-filter-group]")?.dataset.filterGroup;
        this.iconsFilterGroup = this.component.querySelector(".collection-filter-component--icons[data-filter-group]")?.dataset.filterGroup;

        this.init();
      }
    }

    init() {
      this.initSlider();
      this.initEvents();
      document.addEventListener("collection_filter:update", (event) => this.onFilterUpdate(event));
    }

    initEvents() {      
      let componentFilterSelect = this.component.querySelector('.collection-filter-component--location select');
      if (componentFilterSelect && componentFilterSelect != null) {
        componentFilterSelect.addEventListener('change', this.onLocationFilterUpdate.bind(this));
      }
      
      let iconFilterElements = this.component.querySelectorAll('.collection-filter-component--icons a[data-filter]');
      if (iconFilterElements.length > 0) {
        for (let i=0; i<iconFilterElements.length; i++) {
          let element = iconFilterElements[i];
          element.addEventListener('click', this.onIconFilterUpdate.bind(this));
        }
      }
    }

    // Update filter location inputs when location dropdown changes
    onLocationFilterUpdate(event) {
      let componentFilterSelect = event.currentTarget;
      let locationFilterOptions = this.sidebar.querySelectorAll(`[data-filter-group="${this.locationFilterGroup}"] input[data-filter]`);
      let selectedOption = componentFilterSelect.querySelector(`option[data-filter][value="${componentFilterSelect.value}"]`);

      for (let i=0; i<locationFilterOptions.length; i++) {
        let input = locationFilterOptions[i];
        input.checked = false;

        if (input.dataset.filter !== "" && input.dataset.filter === selectedOption.dataset.filter) {
          input.checked = true;
        }
      }
      
      locationFilterOptions[0].dispatchEvent(new Event('input', { bubbles: true}));
    }

    // Update filter inputs when icon elements are clicked
    onIconFilterUpdate(event) {
      let iconsFilterOptions = this.sidebar.querySelectorAll(`[data-filter-group="${this.iconsFilterGroup}"] input[data-filter]`);
      let selectedOption = event.currentTarget;
      let setOptionActive = !selectedOption.classList.contains('active');

      if (selectedOption.classList.contains('disabled')) return;

      if (setOptionActive) {
        selectedOption.classList.add('active');
      } else {
        selectedOption.classList.remove('active');
      }

      for (let i=0; i<iconsFilterOptions.length; i++) {
        let input = iconsFilterOptions[i];
        // Allow user to select multiple icon filter options at once - uncomment this to just enable one option.
        // input.checked = false;

        if (input.dataset.filter === selectedOption.dataset.filter) {
          if (setOptionActive) {
            input.checked = true;
          } else {
            input.checked = false;
          }
        }
      }
      
      iconsFilterOptions[0].dispatchEvent(new Event('input', { bubbles: true}));
    }

    onFilterUpdate(event) {
      let locationFilterOptions = this.sidebar.querySelectorAll(`[data-filter-group="${this.locationFilterGroup}"] input[data-filter]`);
      let iconsFilterOptions = this.sidebar.querySelectorAll(`[data-filter-group="${this.iconsFilterGroup}"] input[data-filter]`);

      // get select dropdown for location and reset disabled options
      let componentFilterSelect = this.component.querySelector('.collection-filter-component--location select');

      if (componentFilterSelect && componentFilterSelect != null) {
        // enable all previously disabled options (except for any placeholder options that should remain disabled, which have a blank value), select first input option
        componentFilterSelect.querySelectorAll('option').forEach((element) => element.disabled = false);
        componentFilterSelect.querySelectorAll('option')[0].selected = true;

        // loop through values in filter sidebar, select active filter, and disable any necessary select options.
        for (let i=0; i<locationFilterOptions.length; i++) {
          let input = locationFilterOptions[i];
          if (input.disabled) {
            componentFilterSelect.querySelector(`option[data-filter="${input.dataset.filter}"]`).disabled = true;
          }

          if (input.checked) {
            componentFilterSelect.querySelector(`option[data-filter="${input.dataset.filter}"]`).selected = true;
          }
        }
      }

      // get element for icons and reset disabled options
      let componentFilterIconsElement = this.component.querySelector('.collection-filter-component--icons');

      if (componentFilterIconsElement && componentFilterIconsElement != null) {
        componentFilterIconsElement.querySelectorAll('a[data-filter]').forEach((element) => {
          element.classList.remove('active');
          element.classList.remove('disabled');
        });
  
        // loop through values in filter sidebar, select any active filters, and disable any necessary options.
        for (let i=0; i<iconsFilterOptions.length; i++) {
          let input = iconsFilterOptions[i];
          if (input.disabled) {
            componentFilterIconsElement.querySelector(`a[data-filter="${input.dataset.filter}"]`).classList.add("disabled");
          }
  
          if (input.checked) {
            componentFilterIconsElement.querySelector(`a[data-filter="${input.dataset.filter}"]`).classList.add("active");
          }
        }
      }
    }

    initSlider() {
      const swiper = new Swiper(".collection-filter--component .swiper", {
        focusableElements: 'a, input, select, option, textarea, button, video, label',
        centerInsufficientSlides: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // scrollbar: {
        //   el: ".swiper-scrollbar",
        //   draggable: true,
        // },
        breakpoints: {
          2100: {
            slidesPerView: 12.4
          },
          1800: {
            slidesPerView: 11.4
          },
          1400: {
            slidesPerView: 10.4,
          },
          1200: {
            slidesPerView: 8.4,
          },
          800: {
            slidesPerView: 5.4,
          },
          600: {
            slidesPerView: 4.4,
          },
          500: {
            slidesPerView: 3.4,
          },
          450: {
            slidesPerView: 3,
          },
          0: {
            slidesPerView: 2.4,
          },
        },
        on: {
          init: function () {
            document
              .querySelectorAll(".collection-filter--component")
              .forEach(function (el) {
                el.classList.remove("hidden");
              });
          },
        },
      });
    }
  }

  // initialize component
  if (document.querySelectorAll(".collection-filter--component").length > 0) {
    let collectionFilterComponent = new CustomCollectionFilterComponent();
  }
})();

// Envision - product gallery lity video popup
(function() {
  if (typeof window.lity === "undefined") return;

  let lityTriggers = document.querySelectorAll('a.lity-popup-trigger[data-gallery-lity]');
  if (lityTriggers.length) {
    lityTriggers.forEach((element) => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        let lityInstance = lity(element.getAttribute("href"), {
          template: `<div class="lity" role="dialog" aria-label="Dialog Window (Press escape to close)" tabindex="-1"><div class="lity-wrap" data-lity-close role="document"><div class="lity-loader" aria-hidden="true">Loading...</div><div class="lity-container"><div class="lity-content"></div><button class="lity-close" type="button" aria-label="Close (Press escape to close)" data-lity-close>&times;</button></div></div></div>`
        });
      });
    });

    document.addEventListener('lity:open', (event, instance) => {
      setTimeout(() => {
        let video = event.target.querySelector('video');
        if (video) {
          video.play();
        }
      }, 500);
    });

    document.addEventListener('lity:close', (event, instance) => {
      let video = event.target.querySelector('video');
      if (video) {
        video.pause();
      }
    });
  }
})();